import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type RecipientCopyrightTransferFormAmendmentView2FieldName = 'applicant_address';

export default function RecipientCopyrightTransferFormAmendmentView1({
  document,
  karaokeOrder,
  onNext,
  getValue,
  setValue,
  getErrors,
} : {
  document: string,
  karaokeOrder: {
    title: string,
    applicant_name: string,
  },
  onNext: () => void,
  getValue: (name: RecipientCopyrightTransferFormAmendmentView2FieldName) => string,
  setValue: (name: RecipientCopyrightTransferFormAmendmentView2FieldName, value: string) => void,
  getErrors: (name: RecipientCopyrightTransferFormAmendmentView2FieldName) => FieldValidationErrorsType,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);

  return (
    <>
      <h2>
        「{karaokeOrder.title}」
        <br />
        契約更新のお願い
      </h2>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright_pt2.png" alt="著作権の手続き" />
        </div>
      </div>
      <p className="mb50">下記の契約書をお読みいただき、同意をお願いします。</p>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: document }} />
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">曲名:</span>
                    <span className="col span_18">{karaokeOrder.title}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">あなたの本名:</span>
                    <span className="col span_18">{karaokeOrder.applicant_name}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">
                      住所
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      <CustomTextInput
                        placeholder=""
                        value={getValue('applicant_address')}
                        setValue={(value) => setValue('applicant_address', value)}
                        validationErrors={getErrors('applicant_address')}
                      />
                    </span>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <CustomCheckbox
                checked={agreement1}
                setChecked={(checked) => setAgreement1(checked)}
              >
                契約内容に同意します。
              </CustomCheckbox>
              <CustomCheckbox
                checked={agreement2}
                setChecked={(checked) => setAgreement2(checked)}
              >
                <a href="/privacy" target="_blank">個人情報保護方針</a>
                に同意します。
              </CustomCheckbox>
            </dl>
            <ul>
              <li className="bt">
                <CustomButton type="default" disabled={!(agreement1 && agreement2)} onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
      <p>
        同意できない場合や、著作権契約を解約したい場合などは
        <a href="https://frekul.com/contact">こちら</a>
        からご連絡ください。
      </p>
    </>
  );
}
